import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as PlayIcon } from "../../assets/Icons/play.svg";
import { useWindowWidth } from "@react-hook/window-size";
import { useSelector } from "react-redux";
import Translate from "../../Components/Multilanguage/Translate";
import { imageUrlCheck } from "../../utils/utils";

const PlayerShowCard = ({ data, onPlayClick }) => {
  const navigate = useNavigate()
  const location = useLocation();
  const windowSize = useWindowWidth();
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  
  const playClickHandler = (item) => {
    if (item?.type === "GENRE") {
      navigate(`/category/${item?.vanity_url}`);
      return;
    }

    if (item?.type === "HOME") {
      navigate(`/genre/${item?.vanity_url}`);
      return;
    }

    if (item?.type === "FASTCHANNEL") {
      const channelId = item?.channel_id || item?.uuid || item?.id || item?.show_id || item?.event_id || null;
      const stateObj = { channel_id: channelId, channelId: channelId, homelive: true };
      if (projectInfo?.projectConfig?.config?.MULTI_CHANNELS_REQUIRED === "true") {
        navigate(`/live-channels?c=${channelId}`, { state: stateObj });
      } else {
        navigate("/live");
      }
      return;
    }

    if (item?.type === "LIVE_EVENT" || item?.type === "UPCOMING_EVENT") {
      navigate(`/event/${item?.vanity_url ? item?.vanity_url : item?.event_id}`, {
        state: { showId: item?.event_id },
      });
      return;
    }
     if (item?.type === "VERTICAL_SHOW") {
      const showIdentifier = item?.vanity_url || item?.show_id;
      navigate(`/vertical-show/${showIdentifier}`, { state: { showId: item?.show_id } });
      return;
    }

    if (item?.show_id) {
      if (item?.video_vanity_url || item?.video_id) {
        navigate(`/videos/${item?.video_vanity_url || item?.video_id}`, {
          state: { 
            showId: item?.show_id,
            videoDetails: item,
            prevPath: location?.pathname
          },
        });
      } else {
        navigate(`/movies/${item?.vanity_url ? item?.vanity_url : item?.show_id}`, {
          state: { 
            showId: item?.show_id,
            type: item?.type
          },
        });
      }
    } 
    else if (item?.event_id) {
      navigate(`/event/${item?.vanity_url ? item?.vanity_url : item?.event_id}`, {
        state: { showId: item?.event_id },
      });
    } 
    else if (item?.type === "VIDEO") {
      navigate(`/videos/${item?.vanity_url}`, {
        state: { videoDetails: item, prevPath: location?.pathname },
      });
    }
  };

  const showClickHandler = () => {
    if (onPlayClick) {
      onPlayClick(data);
    } else {
      playClickHandler(data);
    }
  };
  return (
    <div className="playerShowCard">
      <div className="imageContainer">
        <img src={windowSize<640?data?.logo?data.logo:data?.banner:data?.banner || data?.logo_thumb} alt="Banner" />
        <div className="playIconContainer" onClick={showClickHandler}>
          <PlayIcon />
        </div>
        <div className="metaData">
            <span className="categoryName">{data?.categories?.length>0&&data?.categories[0]?.category_name}</span>
            {/* <h1 className="showName">{data?.show_name}</h1> */}
            <h1 className="showName">
              { (data?.image_title && imageUrlCheck(data.image_title)) ? (
                <img src={data.image_title} alt={data.image_title || data.show_name} className="titleImage" />
                  ) : (
                data?.show_name
              )}
            </h1>
          {data?.director && <span className="director"><Translate textKey={'directed_by'} />  {data?.director}</span>}
          <span className="year">{data?.year}</span>
          <p className="description">{data?.synopsis?.slice(0,250)}{data?.synopsis?.length>250&&"..."}</p>
        </div>
        <div className="bottomGradient"></div>
      </div>
    </div>
  );
};

export default PlayerShowCard;
